import {
  FETCH_ADSENSE_TRANSACTIONS,
  FETCH_ADSENSE_TRANSACTIONS_ERROR,
  CLEAR_ADSENSE_TRANSACTIONS,
} from 'redux/earnings/types';

const initialState = {
  adsenseTransactions: null,
  adsenseTransactionsError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADSENSE_TRANSACTIONS:
      return {
        ...state,
        adsenseTransactions: action.payload.data,
        adsenseTransactionsError: null,
      };
    case FETCH_ADSENSE_TRANSACTIONS_ERROR:
      return {
        ...state,
        adsenseTransactions: null,
        adsenseTransactionsError: action.payload.data,
      };
    case CLEAR_ADSENSE_TRANSACTIONS:
      return {
        ...state,
        adsenseTransactions: null,
        adsenseTransactionsError: null,
      };
    default:
      return state;
  }
};
